import { UserAction } from "../../../shared/interfaces/reducers/reducer.interface";
import * as types from "../const";

const initState = {
  isAddUserOk: false,
};

export default function addTenantUserReducer(
  state = initState,
  action: UserAction,
) {
  switch (action.type) {
    case types.POST_ADD_USER_REQUEST: {
      return { ...state, isAddUserOk: false };
    }
    case types.POST_ADD_USER_SUCCESS: {
      return { ...state, isAddUserOk: true };
    }
    case types.POST_ADD_USER_ERROR: {
      return { ...state };
    }

    default: {
      return { ...state };
    }
  }
}
